import { Questionnaire } from "@teamprevent/common/questionnaires/model";

export interface PpqModel {
    managersQuestionnaire: Questionnaire;
    employeeQuestionnaire: Questionnaire;
}

export enum ConsentToReleaseTheCertificateAnswers {
    EmployeeToViewCertificateBeforeRelease = "EmployeeToViewCertificateBeforeRelease",
    ReleaseCertificate = "ReleaseCertificate",
    AdminToApproveAlternativeChoice = "AdminToApproveAlternativeChoice"
}

export const evidenceApiUrl = "/api/ppq/evidence";
